import { useCallback } from 'react';
import { useBlocker, useBeforeUnload } from 'react-router-dom';

export function Prompt({ when, message }) {
  useBlocker(
      useCallback(
          ({ currentLocation, nextLocation }) => {
            if (when && currentLocation.pathname !== nextLocation.pathname) {
              return !window.confirm(message);
            }
            return false;
          },
          [when, message]
      )
  );

  useBeforeUnload(
    useCallback(
      (event) => {
        if (when) {
          event.preventDefault();
          event.returnValue = message;
        }
      },
      [when, message]
    )
  );

  return null;
}